<ng-container *transloco="let t">
    <div class="space-y-4">
        <ng-container *ngIf="isShowQrCode(); else shareActionsTmpl">
            <p>{{ t('scan_this_code_to_start_ordering') }}</p>
            <div class="text-center">
                <qrcode [qrdata]="joinLink()" [width]="200" [errorCorrectionLevel]="'M'" class="inline-block"></qrcode>
            </div>
            <button tuiButton appearance="outline" (click)="toggleShowQrCode()" class="w-full" size="m">
                <tui-svg [src]="'tuiIconArrowLeft'"></tui-svg>
                {{ t('back') }}
            </button>
        </ng-container>

        <ng-template #shareActionsTmpl>
            <img
                [ngSrc]="'/assets/images/135_2.svg'"
                [width]="382"
                [height]="255"
                alt="share-order"
                class="h-auto w-full max-w-xl rounded-lg my-4"
            />

            <div class="py-4">
                <div class="space-y-3">
                    <div *ngFor="let member of members(); trackByProperty: 'id'" class="flex items-center space-x-2">
                        <tui-avatar [autoColor]="true" size="m" [text]="member.name"></tui-avatar>
                        <div class="space-y-1">
                            <p class="text-sm font-medium leading-none">{{ member.name }}</p>
                            <p class="text-sm text-muted-foreground" *ngIf="member.is_owner">{{ t('group_owner') }}</p>
                        </div>
                        <div class="flex-auto"></div>
                        <button
                            *ngIf="isOwner() && !member.is_owner"
                            (click)="removeMember(member.id)"
                            tuiButton
                            appearance="secondary-destructive"
                            size="s"
                            [icon]="'tuiIconTrash'"
                        >
                            {{ t('remove_from_group') }}
                        </button>
                    </div>
                </div>
            </div>

            <button tuiButton appearance="primary" (click)="shareOrder()" class="w-full" size="m">
                <tui-svg [src]="'tuiIconSend'"></tui-svg>
                {{ t('invite_more_members') }}
            </button>
            <button tuiButton appearance="secondary" (click)="toggleShowQrCode()" class="w-full" size="m">
                <tui-svg [src]="'svg::qr-code'"></tui-svg>
                {{ t('show_qrcode') }}
            </button>
        </ng-template>
    </div>
</ng-container>
